// Auto-import SASS generated CSS
import './index.css';

export type {SimpleDropdownProps} from './SimpleDropdown';
export {default as default} from './SimpleDropdown';
